<template>
    <div>
        <div class="main-button-bar">
            <el-row class="search-row">
                <el-select v-model="params.typeId" clearable placeholder="选择类型" class="search-item">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select v-model="params.status" clearable placeholder="选择状态" class="search-item">
                    <el-option
                        v-for="item in status"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-date-picker
                    type="date"
                    placeholder="开始支出日期"
                    v-model="params.expendTimeStart"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="截止支出日期"
                    v-model="params.expendTimeEnd"
                    style="width:217px"
                    class="search-item"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>

                
            </el-row>

            <el-row class="search-row">

                <el-select v-model="params.needAccount" clearable placeholder="是否报销" class="search-item">
                    <el-option
                        v-for="item in isAccounst"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-input v-model="params.bills" placeholder="流水号" class="search-item"></el-input>
                <el-input v-model="params.id" placeholder="支出单号" class="search-item"></el-input>
                <el-input v-model="params.accountId" placeholder="报销单号" class="search-item"></el-input>
                <el-button type="primary" size="small" @click="page(1)">搜索</el-button>
            </el-row>
        </div>

        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 135"
            class="finance-expense-table"
        >
            <el-table-column prop="id" label="支出单号" width="200"></el-table-column>

            <el-table-column prop="cost" label="支出金额" width="100">
                <template slot-scope="expend">{{ $tools.parsecost(expend.row.cost, true)}}</template>
            </el-table-column>

            <el-table-column prop="typeName" label="支出类型" width="100"></el-table-column>

            <el-table-column prop="hasFile" label="附件" width="100">
                 <template slot-scope="expend">
                     <i v-if="expend.row.hasFile == 'Y'" class="el-icon-paperclip" style="cursor: pointer" @click="showFile(expend.row.id)"></i>
                 </template>
            </el-table-column>

            <el-table-column prop="expendTime" label="支出日期" width="100">
                <template slot-scope="expend">{{ $tools.timestampToDay(expend.row.expendTime)}}</template>
            </el-table-column>
            
            <el-table-column prop="needAccount" label="是否报销" width="80">
                <template slot-scope="expend">
                    <el-tag type="success" v-if="expend.row.needAccount == 'Y'">是</el-tag>
                    <el-tag type="danger" v-if="expend.row.needAccount == 'N'">否</el-tag>
                </template>
            </el-table-column>

            <el-table-column prop="bills" label="关联流水" width="100">
                <template slot-scope="expend">
                    <finance-cell-view :datas="expend.row.bills" type="B"></finance-cell-view>
                </template>
            </el-table-column>

            <el-table-column prop="accountId" label="关联报销" width="100">
                <template slot-scope="expend">
                    <finance-cell-view :datas="expend.row.accountId" type="A"></finance-cell-view>
                </template>
            </el-table-column>

            <el-table-column prop="status" label="状态" width="120">
                <template slot-scope="expend">
                    <el-tag type="info" v-if="expend.row.status == 'INT'">未操作</el-tag>
                    <el-tag type="info" v-if="expend.row.status == 'WAIT'">等待入账</el-tag>
                    <el-tag type="info" v-if="expend.row.status == 'WAIT_ACCOUNT'">待发起报销</el-tag>
                    <el-tag type="info" v-if="expend.row.status == 'WAIT_REVIEW'">待报销审核</el-tag>
                    <el-tag type="info" v-if="expend.row.status == 'WAIT_PAY'">等待打款</el-tag>
                    <el-tag type="info" v-if="expend.row.status == 'PAID'">已打款</el-tag>
                    <el-tag type="danger" v-if="expend.row.status == 'INVALID'">废弃</el-tag>
                    <el-tag type="success" v-if="expend.row.status == 'VALID'">已入账</el-tag>
                    <el-tag type="danger" v-if="expend.row.status == 'UNPASS'">未通过</el-tag>
               </template>
            </el-table-column>

            <el-table-column prop="remark" label="备注" width="300"></el-table-column>

            <el-table-column prop="creatorName" label="登记人" width="100"></el-table-column>

            <el-table-column prop="createTime" label="登记时间" width="180">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.createTime)}}</template>
            </el-table-column>

            <el-table-column prop="reviewerName" label="审核人" width="100"></el-table-column>

            <el-table-column prop="reviewTime" label="审核时间" width="180">
                <template slot-scope="expend">{{ $tools.timestampToTime(expend.row.reviewTime)}}</template>
            </el-table-column>

            <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                    <el-button
                        v-if="scope.row.status == 'WAIT'"
                        type="text"
                        size="small"
                        @click="review(scope.row.id, 'VALID', '入账')"
                    > 入账</el-button>

                    <el-button
                        v-if="scope.row.status == 'WAIT'"
                        type="text"
                        size="small"
                        @click="review(scope.row.id, 'UNPASS', '驳回')"
                    > 驳回</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
            :page-size.sync="params.size"
        ></el-pagination>

        <finance-expense-create-diaolog :show.sync="showDialog" @afterAdd="page"></finance-expense-create-diaolog>
        <sn-file-dialog :show.sync="showFileDialog" :relateId="relateId" relateType="FinanceExpense" :canEdit="false"></sn-file-dialog>
    </div>
</template>

<script>
import FinanceCellView from './Finance-cell-view.vue';
import SnFileDialog from '../components/SnFileDialog.vue';
import FinanceExpenseCreateDiaolog from './Finance-expense-create-diaolog.vue';
export default {
    components: {FinanceExpenseCreateDiaolog, FinanceCellView,SnFileDialog  },
    data() {
        return {
            showDialog: false,
            showFileDialog: false,
            relateId: null,
            shops: null,
            types: null,
            params: {
                typeId: null,
                shopId: null,
                status: null,
                orderId: null,
                expendTimeStart: null,
                expendTimeEnd: null,
                current: null,
                total: null,
            },
            records: null,
            status: [
                { id: "INT", name: "未操作" },
                { id: "WAIT", name: "等待入账" },
                { id: "WAIT_ACCOUNT", name: "待发起报销" },
                { id: "WAIT_REVIEW", name: "待报销审核" },
                { id: "INVALID", name: "废弃" },
                { id: "VALID", name: "已入账" },
                { id: "UNPASS", name: "未通过" }
            ],
            isAccounst: [
                { id: "Y", name: "是" },
                { id: "N", name: "否" }
            ]
        };
    },
    methods: {
        getType() {
            let _this = this;

            _this.$http.post(
                ["finance/expense/type/all"],
                [
                    function (data) {
                        _this.types = data;
                    },
                ],
                "none"
            );
        },
        page(current) {
            let _this = this;

            if (current) {
                _this.params.current = current;
            }

            _this.$http.post(
                ["finance/expense/page", _this.params],
                [
                    function (data) {
                        _this.records = data.records;
                        _this.params.total = data.total;
                    },
                ],
                ".finance-expense-table"
            );
        },
        review(id, status, title) {
            let _this = this;

            _this.$tConfirm.show("确认进行【" + title + "】操作？", function () {
                _this.$http.post(
                    ["finance/expense/review", { id: id, status: status }],
                    [
                        function (data) {
                            _this.page(1);
                        },
                    ],
                    ".finance-expense-table"
                );
            });
        },
        showAddDialog() {
            this.showDialog = true;
        },
        showFile(id) {
            let _this = this;
            _this.relateId = id;
            _this.showFileDialog = true;
        },
    },
    mounted() {
        this.getType();
        this.page(1);
    },
};
</script>

<style lang="scss">
</style>